const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    backgroundColor: theme.palette.white,
  },
  rootSubscribeMain: {
    paddingBottom: theme.spacing(6),
  },
  content: {
    display: 'flex',
    flex: '1',
  },
})

export default styles
